module.exports = __webpack_public_path__ + "static/media/12.3b1c840b.png";